"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeltaViewType = exports.DimensionSummaryType = void 0;
var DimensionSummaryType;
(function (DimensionSummaryType) {
    DimensionSummaryType["signatureNonSignature"] = "signatureNonSignature";
    DimensionSummaryType["dichotomyArchetype"] = "dichotomyArchetype";
    DimensionSummaryType["scoreAndDescriptor"] = "scoreAndDescriptor";
    DimensionSummaryType["twoByTwoGrid"] = "twoByTwoGrid";
})(DimensionSummaryType = exports.DimensionSummaryType || (exports.DimensionSummaryType = {}));
var ContentAvailability;
(function (ContentAvailability) {
    ContentAvailability["connection"] = "connection";
    ContentAvailability["self"] = "self";
})(ContentAvailability || (ContentAvailability = {}));
var DeltaViewType;
(function (DeltaViewType) {
    DeltaViewType["natureDelta"] = "natureDelta";
    DeltaViewType["archetypeDelta"] = "archetypeDelta";
    DeltaViewType["topNDelta"] = "topNDelta";
    DeltaViewType["twoByTwoDelta"] = "twoByTwoDelta";
    DeltaViewType["spectrumDelta"] = "spectrumDelta";
    DeltaViewType["topTraitDelta"] = "topTraitDelta";
})(DeltaViewType = exports.DeltaViewType || (exports.DeltaViewType = {}));
